// Port of api/fuel/app/classes/filter/package/lists/listing/prepare/general.php
export default {
	run: function(local, global) {
		var list = global.results && global.results[local.id] ? global.results[local.id] : null
		var editions = global.editions && global.editions[local.id] ? global.editions[local.id] : []
		var edition = editions.length ? editions[0] : null

		local.list = list ? list.to_array() : false
		local.edition = edition ? edition.to_array() : false
		local.games = edition && global.games && global.games[edition.get_id()] ? global.games[edition.get_id()] : []

		return local
	}
}
